/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FinchPayFrequency {
  annually = 'annually',
  semi_annually = 'semi_annually',
  quarterly = 'quarterly',
  monthly = 'monthly',
  semi_monthly = 'semi_monthly',
  bi_weekly = 'bi_weekly',
  weekly = 'weekly',
  daily = 'daily',
  other = 'other',
}
